export default {"src":"/_next/static/media/card.26c61870.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};